import queryGuidelineComponent from './queryGuideline.component';

export default angular.module('app.components.queryGuideline', [])
	.component('queryGuideline', queryGuidelineComponent)
	.name;
